// ============ CONTENEDOR DE PÁGINA CON PADDING OFFLINE ============
// client/src/components/layout/PageContainer.tsx

import { ReactNode } from "react";
import { useOffline } from "@/lib/hooks/use-offline";

interface PageContainerProps {
  children: ReactNode;
  className?: string;
}

export function PageContainer({
  children,
  className = "",
}: PageContainerProps) {
  const { isOffline, wasOffline } = useOffline();

  // Ya no necesitamos padding porque App.tsx maneja el espaciado
  // const paddingTop = isOffline || wasOffline ? 'pt-12' : '';

  return <div className={`${className}`}>{children}</div>;
}
